module.exports = __webpack_public_path__ + "img/Ledger_Device_main.931342ea.svg";